import { Button } from "@mui/material";

import { ViewWrapper } from "..";

import Image from "@/assets/svgs/error-500.svg";

interface Props {
  fullScreen?: boolean;
}

export function Error500({ fullScreen = false }: Props) {
  return (
    <ViewWrapper
      title="500: Internal Error"
      subtitle="Oops! Something went wrong. Don't worry, it's not you, it's us. Our dev team has been notified and will begin working on a fix shortly"
      image={Image}
      action={
        <Button variant="outlined" color="primary" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      }
      fullScreen={fullScreen}
    />
  );
}
